import Link from 'next/link'
import * as React from 'react'

import SEO from '@/components/seo/SEO'
import { Button } from '@/components/ui/button'
import RootContainer from '@/containers/root-container'

export default function NotFoundPage() {
  return (
    <RootContainer>
      <SEO title="Page not found" description="This page does not exist." />
      <div className="container mx-auto flex min-h-[50vh] flex-col items-center justify-center px-4 py-16 text-center">
        <h1 className="text-3xl font-bold tracking-tight text-foreground md:text-4xl">This page does not exist</h1>
        <p className="mt-3 max-w-md text-muted-foreground">
          The page you are looking for may have been removed, renamed, or is temporarily unavailable.
        </p>
        <Button asChild className="mt-8">
          <Link href="/">Go to homepage</Link>
        </Button>
      </div>
    </RootContainer>
  )
}
